// @flow
import { RESORT_TRIPADVISOR } from 'Client/cms/toolkit/constants';
import { ProductTripAdvisorLine } from 'Components/lines/product-tripadvisor-line/ProductTripAdvisorLine.jsx';
import { productTripadvisorResolver } from './productTripadvisor.resolver';

export const productTripadvisorDescriptor = {
  name: RESORT_TRIPADVISOR,
  component: ProductTripAdvisorLine,
  resolve: productTripadvisorResolver.resolve,
};
